import React from 'react'

const Loading = () => {
  return (
    <div className="main">
      <h3>this might take a minute...</h3>
      <p>Hang out here, or enter your email below and we’ll notify you when it’s finished.</p>

      <div className="loadingInput">
        <input type="email" placeholder="Email Address" />
        <button>Subscribe</button>
      </div>
    </div>
  )
}

export default Loading
